import React, { ReactElement } from 'react';

import router from '~/core/router';
import { settingsSidebar } from '~/core/sidebar';
import {
  PersonalInformationRoute,
  SecurityRoute,
  SubscriptionRoute,
} from '~/modules/settings';

import { ReactComponent as AccountIcon } from '../assets/account.svg';
import { ReactComponent as CardIcon } from '../assets/card.svg';
import { ReactComponent as SecurityIcon } from '../assets/security.svg';

router.addPrivateRoutes([
  PersonalInformationRoute,
  SecurityRoute,
  SubscriptionRoute,
]);

// TODO! Localization. Check other sidebar elements as well
settingsSidebar.addItems({
  a: [
    {
      key: 'personal_information',
      path: PersonalInformationRoute.path,
      getTitle: PersonalInformationRoute.getTitle,
      Icon: (props): ReactElement => <AccountIcon {...props} />,
    },
    {
      key: 'security',
      path: SecurityRoute.path,
      getTitle: SecurityRoute.getTitle,
      Icon: (props): ReactElement => <SecurityIcon {...props} />,
    },
    {
      key: 'subscription',
      path: SubscriptionRoute.path,
      getTitle: SubscriptionRoute.getTitle,
      Icon: (props): ReactElement => <CardIcon {...props} />,
    },
  ],
});
